import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const appointmentsContainerStyle = css`
  margin-bottom: ${theme.spacing(2)};
  max-height: 250px;
  overflow-y: auto;
`;

export const textStyle = css`
  margin-bottom: ${theme.spacing(1.5)};
`;

export const bannerNotificationStyle = css`
  margin-bottom: ${theme.spacing(3)};
  max-width: 100%;
`;
